// ============================================================================
// DocumentiAziendaBox.jsx
// Componente per gestire i documenti dell'azienda nella sezione 5 di
// SicurezzaAzienda. 4 categorie + scadenza + flag stampa_pos + flag qr +
// archivio + ripristino. Backend: /api/azienda/*
// ============================================================================

import React, { useState, useEffect } from 'react';

const TIPI_DOC_AZIENDA = [
  { id: "obbligatori_legge", label: "Obbligatori per legge",  emoji: "📜", desc: "DURC, Visura, Patente a punti (default: stampa nel POS)" },
  { id: "certificazioni",    label: "Certificazioni",         emoji: "🛡️", desc: "DVR, RSPP, RLS, INAIL, INPS, attestati" },
  { id: "polizze",           label: "Polizze",                emoji: "📑", desc: "RC professionale, RC postuma" },
  { id: "altro",             label: "Altro",                  emoji: "📎", desc: "Documenti vari" },
];

const STATO_LABEL_AZ = {
  ok:           { lbl: "OK",           bg: "#1b4332", color: "#3ecf8e" },
  in_scadenza:  { lbl: "in scadenza",  bg: "#3f3500", color: "#f5c518" },
  scaduto:      { lbl: "SCADUTO",      bg: "#3f0f0f", color: "#ff6b6b" },
  nessuna_data: { lbl: "no data",      bg: "transparent", color: "#4a5068" },
};

function authHeadersAz() {
  const token = (typeof window !== "undefined" && window.localStorage)
    ? window.localStorage.getItem("bertoc_jwt") : null;
  return {
    "Authorization": "Bearer " + (token || ""),
    "Content-Type": "application/json",
  };
}

function FileRowAzienda({ item, onApri, onElimina, onPatch, onArchivia }) {
  const [editingScad, setEditingScad] = useState(false);
  const [scadDraft, setScadDraft] = useState(item.scadenza || "");

  function toDateInputValue(s) {
    if (!s) return "";
    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
    const m = String(s).match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    if (m) return m[3] + "-" + m[2].padStart(2, "0") + "-" + m[1].padStart(2, "0");
    return "";
  }

  const stato = STATO_LABEL_AZ[item.stato] || STATO_LABEL_AZ.nessuna_data;
  const giorni = item.giorni_rimanenti;

  return (
    <div style={{
      display: "flex", alignItems: "center", justifyContent: "space-between",
      padding: "8px 0", fontSize: 12, color: "#e8eaf2",
      borderBottom: "1px solid #2a2e4533",
    }}>
      <div style={{ flex: 1, minWidth: 0, overflow: "hidden" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
          <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", flex: 1 }}>
            📄 {item.filename}
          </span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginTop: 4, fontSize: 10, flexWrap: "wrap" }}>
          <span style={{
            padding: "1px 8px",
            borderRadius: 10,
            background: stato.bg,
            color: stato.color,
            fontWeight: 600,
          }}>
            {stato.lbl}{giorni != null && (giorni >= 0 ? " · " + giorni + "gg" : " · " + Math.abs(giorni) + "gg fa")}
          </span>
          {!editingScad ? (
            <button
              onClick={() => { setScadDraft(toDateInputValue(item.scadenza)); setEditingScad(true); }}
              style={{ background: "transparent", border: "none", color: "#7b82a0", cursor: "pointer", fontSize: 10, padding: 0, textDecoration: "underline" }}
            >{item.scadenza ? "modifica" : "+ scadenza"}</button>
          ) : (
            <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
              <input
                type="date"
                value={scadDraft}
                onChange={e => setScadDraft(e.target.value)}
                style={{ background: "#0f1117", color: "#e8eaf2", border: "1px solid #2a2e45", borderRadius: 4, padding: "2px 6px", fontSize: 11, width: 130 }}
                autoFocus
              />
              <button
                onClick={async () => { await onPatch({ scadenza: scadDraft }); setEditingScad(false); }}
                style={{ background: "#f5a623", border: "none", color: "#1a1d27", cursor: "pointer", fontSize: 10, padding: "2px 6px", borderRadius: 4, fontWeight: 600 }}
              >✓</button>
              <button
                onClick={() => setEditingScad(false)}
                style={{ background: "transparent", border: "1px solid #2a2e45", color: "#7b82a0", cursor: "pointer", fontSize: 10, padding: "2px 6px", borderRadius: 4 }}
              >✕</button>
            </span>
          )}
          <label style={{ display: "flex", alignItems: "center", gap: 3, cursor: "pointer", fontSize: 10, fontWeight: 600, color: item.stampa_pos ? "#f5a623" : "#4a5068" }}>
            <input
              type="checkbox"
              checked={!!item.stampa_pos}
              onChange={e => onPatch({ stampa_pos: e.target.checked })}
              style={{ margin: 0, cursor: "pointer" }}
            />
            🖨️ Stampa POS
          </label>
          <label style={{ display: "flex", alignItems: "center", gap: 3, cursor: "pointer", fontSize: 10, fontWeight: 600, color: item.qr ? "#378ADD" : "#4a5068" }}>
            <input
              type="checkbox"
              checked={!!item.qr}
              onChange={e => onPatch({ qr: e.target.checked })}
              style={{ margin: 0, cursor: "pointer" }}
            />
            🔗 QR
          </label>
        </div>
      </div>
      <div style={{ display: "flex", gap: 6, marginLeft: 10 }}>
        <button onClick={onApri} title="Apri PDF" style={{ background: "transparent", border: "none", cursor: "pointer", color: "#378ADD", fontSize: 13, padding: "2px 6px" }}>👁</button>
        <button onClick={onArchivia} title="Sposta in archivio" style={{ background: "transparent", border: "none", cursor: "pointer", color: "#7b82a0", fontSize: 13, padding: "2px 6px" }}>📦</button>
        <button onClick={onElimina} title="Elimina" style={{ background: "transparent", border: "none", cursor: "pointer", color: "#f06060", fontSize: 13, padding: "2px 6px" }}>✕</button>
      </div>
    </div>
  );
}

export default function DocumentiAziendaBox() {
  const [files, setFiles] = useState({ obbligatori_legge: [], certificazioni: [], polizze: [], altro: [] });
  const [archivio, setArchivio] = useState({ obbligatori_legge: [], certificazioni: [], polizze: [], altro: [] });
  const [archivioCount, setArchivioCount] = useState({});
  const [showArchivio, setShowArchivio] = useState({});
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(null);
  const [errore, setErrore] = useState(null);

  async function caricaFiles(includeArc) {
    setLoading(true);
    setErrore(null);
    try {
      const url = "/api/azienda/files" + (includeArc ? "?include_archivio=true" : "");
      const r = await fetch(url, { headers: authHeadersAz() });
      if (!r.ok) throw new Error("HTTP " + r.status);
      const j = await r.json();
      if (!j.ok) throw new Error(j.error || "Errore");
      setFiles(j.files || {});
      if (j.archivio) setArchivio(j.archivio);
      setArchivioCount(j.archivio_count || {});
    } catch (err) {
      setErrore(err.message);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => { caricaFiles(false); }, []);

  useEffect(() => {
    const anyOpen = Object.values(showArchivio).some(v => v);
    if (anyOpen) caricaFiles(true);
  }, [showArchivio]);

  async function handleUpload(tipo, file) {
    if (!file) return;
    if (file.type && file.type !== "application/pdf") {
      alert("Seleziona un file PDF");
      return;
    }
    setUploading(tipo);
    try {
      const token = (typeof window !== "undefined" && window.localStorage)
        ? window.localStorage.getItem("bertoc_jwt") : null;
      const fd = new FormData();
      fd.append("file", file);
      fd.append("tipo", tipo);
      const r = await fetch("/api/azienda/upload", {
        method: "POST",
        headers: { "Authorization": "Bearer " + token },
        body: fd,
      });
      if (!r.ok) {
        const err = await r.json().catch(() => ({}));
        throw new Error(err.error || ("HTTP " + r.status));
      }
      const uploadResp = await r.json().catch(() => ({}));
      await caricaFiles(Object.values(showArchivio).some(v => v));

      // F5c: analisi AI in background
      const fnAnalizzato = uploadResp.filename || file.name;
      analizzaConAI("azienda", tipo, fnAnalizzato).then(() => {
        caricaFiles(Object.values(showArchivio).some(v => v));
      }).catch(() => {});

    } catch (err) {
      alert("Upload fallito: " + err.message);
    } finally {
      setUploading(null);
    }
  }

  // F5c: helper analisi AI per documenti azienda
  async function analizzaConAI(categoria, subTipo, filename) {
    try {
      const token = (typeof window !== "undefined" && window.localStorage)
        ? window.localStorage.getItem("bertoc_jwt") : null;
      const r = await fetch("/api/documenti/analizza-meta", {
        method: "POST",
        headers: { "Authorization": "Bearer " + token, "Content-Type": "application/json" },
        body: JSON.stringify({ categoria, subTipo, filename }),
      });
      const j = await r.json();
      if (!r.ok || !j.ok) throw new Error(j.error || ("HTTP " + r.status));
      const d = j.dati || {};
      const parts = [];
      if (d.tipoDocumento) parts.push(d.tipoDocumento);
      if (d.dataScadenza) parts.push("scadenza: " + d.dataScadenza);
      if (d.ente) parts.push("ente: " + d.ente);
      if (d.numeroDocumento) parts.push("n. " + d.numeroDocumento);
      const msg = "AI: " + (parts.length > 0 ? parts.join(" | ") : "nessun dato estratto");
      console.log("[F5c]", filename, msg);
      alert("✨ " + filename + "\n" + msg);
    } catch (e) {
      console.warn("[F5c] errore analisi AI:", e.message);
    }
  }

  async function handleApri(tipo, filename, daArchivio) {
    try {
      const token = (typeof window !== "undefined" && window.localStorage)
        ? window.localStorage.getItem("bertoc_jwt") : null;
      const baseUrl = daArchivio ? "/api/azienda/file/archivio" : "/api/azienda/file";
      /* APRI_SAFARI_v1: URL diretto col token, i blob non si aprono in Safari */
      const url = baseUrl + "?tipo=" + encodeURIComponent(tipo)
                + "&filename=" + encodeURIComponent(filename);
      const w = window.open("", "_blank"); /* PASS_FILE_v1: pass breve, valido 5 minuti solo per questo file */
      try {
        const rp = await fetch("/api/pass-file", { method: "POST", headers: { "Content-Type": "application/json", "Authorization": "Bearer " + (token || "") }, body: JSON.stringify({ url: url }) });
        const jp = await rp.json();
        if (!rp.ok) throw new Error(jp.error || ("HTTP " + rp.status));
        if (w) { w.opener = null; w.location.href = jp.url; } else { window.location.href = jp.url; }
      } catch (e2) { if (w) w.close(); throw e2; }
      setTimeout(() => {
        if (!w || w.closed) {
          console.warn("Apertura PDF: finestra non disponibile", url);
        }
      }, 1200);
    } catch (err) {
      alert("Apertura fallita: " + err.message);
    }
  }

  async function handleScarica(tipo, filename, daArchivio) {
    try {
      const token = (typeof window !== "undefined" && window.localStorage)
        ? window.localStorage.getItem("bertoc_jwt") : null;
      const baseUrl = daArchivio ? "/api/azienda/file/archivio" : "/api/azienda/file";
      const url = baseUrl + "?tipo=" + encodeURIComponent(tipo) + "&filename=" + encodeURIComponent(filename);
      const r = await fetch(url, { headers: { "Authorization": "Bearer " + token } });
      if (!r.ok) throw new Error("HTTP " + r.status);
      const blob = await r.blob();
      const blobUrl = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
    } catch (err) {
      alert("Download fallito: " + err.message);
    }
  }

  function handleMail(tipo, filename) {
    const oggetto = "Documento: " + filename;
    const corpo = "Salve,\n\nin allegato trasmettiamo il documento richiesto.\n\nCordiali saluti,\nBERTOC PROJECT SRL";
    window.location.href = "mailto:?subject=" + encodeURIComponent(oggetto) + "&body=" + encodeURIComponent(corpo);
  }

  async function handleElimina(tipo, filename, daArchivio) {
    const conf = daArchivio
      ? "Eliminare DEFINITIVAMENTE '" + filename + "' dall'archivio?"
      : "Eliminare '" + filename + "'?";
    if (!window.confirm(conf)) return;
    try {
      const baseUrl = daArchivio ? "/api/azienda/file/archivio" : "/api/azienda/file";
      const url = baseUrl + "?tipo=" + encodeURIComponent(tipo) + "&filename=" + encodeURIComponent(filename);
      const r = await fetch(url, { method: "DELETE", headers: authHeadersAz() });
      if (!r.ok) {
        const err = await r.json().catch(() => ({}));
        throw new Error(err.error || ("HTTP " + r.status));
      }
      await caricaFiles(Object.values(showArchivio).some(v => v));
    } catch (err) {
      alert("Eliminazione fallita: " + err.message);
    }
  }

  async function patchMeta(tipo, filename, patch) {
    try {
      const r = await fetch("/api/azienda/file/meta", {
        method: "PATCH",
        headers: authHeadersAz(),
        body: JSON.stringify({ tipo: tipo, filename: filename, ...patch }),
      });
      if (!r.ok) {
        const err = await r.json().catch(() => ({}));
        throw new Error(err.error || ("HTTP " + r.status));
      }
      await caricaFiles(Object.values(showArchivio).some(v => v));
    } catch (err) {
      alert("Aggiornamento fallito: " + err.message);
    }
  }

  async function handleArchivia(tipo, filename) {
    if (!window.confirm("Spostare '" + filename + "' nell'archivio?")) return;
    try {
      const r = await fetch("/api/azienda/file/archivia", {
        method: "POST",
        headers: authHeadersAz(),
        body: JSON.stringify({ tipo: tipo, filename: filename, motivo: "manuale" }),
      });
      if (!r.ok) {
        const err = await r.json().catch(() => ({}));
        throw new Error(err.error || ("HTTP " + r.status));
      }
      await caricaFiles(Object.values(showArchivio).some(v => v));
    } catch (err) {
      alert("Archiviazione fallita: " + err.message);
    }
  }

  async function handleRipristina(tipo, archivedFilename) {
    try {
      const r = await fetch("/api/azienda/file/ripristina", {
        method: "POST",
        headers: authHeadersAz(),
        body: JSON.stringify({ tipo: tipo, filename: archivedFilename }),
      });
      if (!r.ok) {
        const err = await r.json().catch(() => ({}));
        throw new Error(err.error || ("HTTP " + r.status));
      }
      await caricaFiles(true);
    } catch (err) {
      alert("Ripristino fallito: " + err.message);
    }
  }

  if (loading) return <div style={{ fontSize: 12, color: "#7b82a0", padding: "10px 0" }}>Caricamento...</div>;
  if (errore) return <div style={{ fontSize: 12, color: "#f06060", padding: "10px 0" }}>Errore: {errore}</div>;

  return (
    <div style={{ padding: "14px 0" }}>
      <div style={{ fontSize: 12, color: "#7b82a0", marginBottom: 14 }}>
        Carica i documenti aziendali. <strong>Stampa POS</strong> = il file viene allegato al PDF stampabile.
        <strong> QR</strong> = il file appare nella pagina pubblica via QR code (per controlli sul cantiere).
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        {TIPI_DOC_AZIENDA.map(cat => {
          const lista = files[cat.id] || [];
          const arcLista = archivio[cat.id] || [];
          const arcN = arcLista.length || archivioCount[cat.id] || 0;
          const isUploading = uploading === cat.id;
          const arcOpen = !!showArchivio[cat.id];
          return (
            <div key={cat.id} style={{
              border: "1px solid #2a2e45",
              borderRadius: 10,
              padding: "12px 14px",
              background: "#1a1d27",
            }}>
              <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginBottom: 8, gap: 12 }}>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 13, color: "#e8eaf2", fontWeight: 700 }}>
                    {cat.emoji} {cat.label} <span style={{ color: "#7b82a0", fontWeight: 400 }}>({lista.length})</span>
                  </div>
                  <div style={{ fontSize: 11, color: "#4a5068", marginTop: 2 }}>{cat.desc}</div>
                </div>
                <label style={{
                  fontSize: 11,
                  color: "#f5a623",
                  cursor: isUploading ? "wait" : "pointer",
                  fontWeight: 600,
                  padding: "5px 12px",
                  border: "1px solid #f5a62355",
                  borderRadius: 6,
                  whiteSpace: "nowrap",
                }}>
                  {isUploading ? "Caricamento..." : "+ Carica PDF"}
                  <input
                    type="file"
                    accept="application/pdf,.pdf"
                    style={{ display: "none" }}
                    disabled={isUploading}
                    onChange={e => {
                      const f = e.target.files && e.target.files[0];
                      if (f) handleUpload(cat.id, f);
                      e.target.value = "";
                    }}
                  />
                </label>
              </div>
              {lista.length === 0 && (
                <div style={{ fontSize: 11, color: "#4a5068", fontStyle: "italic" }}>nessun documento caricato</div>
              )}
              {lista.map(item => (
                <FileRowAzienda
                  key={item.filename}
                  item={item}
                  onApri={() => handleApri(cat.id, item.filename, false)}
                  onElimina={() => handleElimina(cat.id, item.filename, false)}
                  onPatch={(patch) => patchMeta(cat.id, item.filename, patch)}
                  onArchivia={() => handleArchivia(cat.id, item.filename)}
                />
              ))}

              {arcN > 0 && (
                <div style={{ marginTop: 8, paddingTop: 8, borderTop: "1px dashed #2a2e45" }}>
                  <button
                    onClick={() => setShowArchivio(s => ({ ...s, [cat.id]: !s[cat.id] }))}
                    style={{
                      background: "transparent",
                      border: "none",
                      color: "#7b82a0",
                      cursor: "pointer",
                      fontSize: 11,
                      fontWeight: 600,
                      padding: 0,
                    }}
                  >
                    {arcOpen ? "▾" : "▸"} 📦 Archivio ({arcN})
                  </button>
                  {arcOpen && (
                    <div style={{ marginTop: 6, opacity: 0.65 }}>
                      {arcLista.length === 0 ? (
                        <div style={{ fontSize: 11, color: "#4a5068", fontStyle: "italic" }}>caricamento...</div>
                      ) : arcLista.map(item => (
                        <div key={item.filename} style={{ fontSize: 11, color: "#7b82a0", padding: "4px 0" }}>
                          📄 <span style={{ textDecoration: "line-through" }}>{item.nome_originale || item.filename}</span>
                          {" · "}
                          <button onClick={() => handleApri(cat.id, item.filename, true)} style={{ background: "transparent", border: "none", color: "#378ADD", cursor: "pointer", fontSize: 11 }}>👁 apri</button>
                          {" · "}
                          <button onClick={() => handleRipristina(cat.id, item.filename)} style={{ background: "transparent", border: "none", color: "#3ecf8e", cursor: "pointer", fontSize: 11 }}>↺ ripristina</button>
                          {" · "}
                          <button onClick={() => handleElimina(cat.id, item.filename, true)} style={{ background: "transparent", border: "none", color: "#f06060", cursor: "pointer", fontSize: 11 }}>✕ elimina</button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
